<template>
  <div>
    <a-card title="订单结算" :bordered="false">
      <div class="Search">
        <a-input v-model="sNo" style="width:220px;margin-right: 8px" placeholder="请输入结算单号" />
        <a-input v-model="order_sNo" style="width:220px;margin-right: 8px" placeholder="请输入订单编号" />
        <a-select v-model="state" style="width: 160px;margin-right: 8px" placeholder="请选择结算状态">
          <a-select-option value="1">
            已结算
          </a-select-option>
          <a-select-option value="2">
            待结算
          </a-select-option>
        </a-select>
        <a-range-picker style="margin-right: 8px" @change="onChange" format="YYYY/MM/DD HH:mm:ss"
          :placeholder="['请选择开始时间', '请选择结束时间']" />
        <a-button @click="handleReset" style="margin-right: 8px">重置</a-button>
        <a-button type="primary" @click="query">查询</a-button>
        <a-button style="float: right" @click="download()">导出</a-button>
      </div>
      <div>
        <a-table :columns="columns" :pagination="pagination" :data-source="datasource" @change="handleTableChange"
          :scroll="{ x: 1650,y: '100%' }">
          <template slot="z_price2" slot-scope="text, record">
            <span>{{record.z_price}}</span>
          </template>
          <template slot="action" slot-scope="text, record">
            <a @click="see(record.sNo)">查看</a>
            <span>｜</span>
            <a @click="del(record.sNo)">删除</a>
          </template>
        </a-table>
      </div>
    </a-card>
    <!-- 导出 -->
    <a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
      <div class="derive">
        <div @click="onDownload('This_page')">
          <a-icon type="file-text" style="font-size:26px;" />
          <div>导出本页</div>
        </div>

        <div @click="onDownload('whole')">
          <a-icon type="snippets" style="font-size:26px;" />
          <div>导出全部</div>
        </div>

        <div @click="onDownload('inquiry')">
          <a-icon type="file-search" style="font-size:26px;" />
          <div>导出查询</div>
        </div>
      </div>
    </a-modal>
    <a-modal v-model="visible" title="提示" @ok="handleOk" @cancel="handleCancel">
      <p>是否删除此订单？</p>
    </a-modal>
  </div>
</template>

<script>
  export default {
    name: "index",
    data() {
      return {
        sNo: '',
        order_sNo: '',
        state: undefined,
        columns: [],
        datasource: [],
        page: 1,
        order_No: '',
        visible: false,
        startdate: '',
        enddate: '',
        visible1: false,
        urls: '',
        searchData: {},
        pagination: {
          total: 0,
          pageSize: 10, //每页中显示10条数据
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
          showTotal: total => `共有 ${total} 条数据`, //分页中显示总的数据
        }
      }
    },
    mounted() {
      this.columns = [{
          title: "结算单号",
          key: "id",
          dataIndex: "id",
          align: 'center',
          width: 100,
          fixed: 'left'
        },
        {
          title: "结算金额",
          key: "z_price",
          dataIndex: "z_price",
          align: 'center',
          width: 100
        },
        // {
        //   title: "佣金",
        //   key: "commission",
        //   dataIndex: "commission",
        //   align: 'center',
        //   width: 100
        // },
        // {
        //   title: "退还佣金",
        //   key: "r_commission",
        //   dataIndex: "r_commission",
        //   align: 'center',
        //   width: 100
        // },

        {
          title: "订单编号",
          key: "sNo",
          dataIndex: "sNo",
          align: 'center',
          width: 220
        },
        {
          title: "订单金额",
          key: "z_price2",
          dataIndex: "z_price2",
          scopedSlots: {
            customRender: "z_price2"
          },
          align: 'center',
          width: 100
        },
        {
          title: "退单金额",
          key: "return_money",
          dataIndex: "return_money",
          align: 'center',
          width: 100
        },
        {
          title: "结算状态",
          key: "status_name",
          dataIndex: "status_name",
          align: 'center',
          width: 100
        },
        {
          title: "结算时间",
          key: "arrive_time",
          dataIndex: "arrive_time",
          align: 'center',
          width: 200
        },
        {
          title: "运费",
          key: "z_freight",
          dataIndex: "z_freight",
          align: 'center',
          width: 100
        },
        {
          title: "店铺优惠",
          key: "mch_discount",
          dataIndex: "mch_discount",
          align: 'center',
          width: 100
        },
        {
          title: "平台优惠",
          key: "preferential_amount",
          dataIndex: "preferential_amount",
          align: 'center',
          width: 100
        },
        {
          title: "订单生成时间",
          key: "add_time",
          dataIndex: "add_time",
          align: 'center',
          width: 200
        },
        {
          title: "操作",
          key: "action",
          dataIndex: "action",
          scopedSlots: {
            customRender: "action"
          },
          align: 'center',
          width: 150,
          fixed: 'right'
        },
      ]
      this._axios()
    },
    methods: {
      query() {
        this.page = 1
        this._axios()
      },
      _axios() {
        let url = '?module=pc_api&action=order&m=SettlemntIndex'
        let data = {
          search: this.sNo,
          sNo: this.order_sNo,
          status: this.state,
          startdate: this.startdate,
          enddate: this.enddate,
          pageto: '',
          pagesize: this.pagination.pageSize,
          page: this.page
        }
        this.searchData = data
        this.$request.post(url, data).then(res => {
          if (res.code == 200) {
            this.datasource = res.data.list
            this.pagination.total = Number(res.data.total)
          }
        })
      },
      handleOk() {
        let data = {
          data: this.order_No
        }
        let url = '?module=pc_api&action=order&m=delSettlementOrder'
        this.$request.post(url, data).then(res => {
          if (res.code == 200) {
            this.$message.success(res.message)
            this.visible = false
            this._axios()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      see(sNo) {
        this.$router.push('SettlementOrder/see?sNo=' + sNo);
        // this.$router.push('SettlementOrder/see/' + sNo);
      },
      del(sNo) {
        this.order_No = sNo
        this.visible = true
      },
      handleTableChange(e) {
        this.handleReset()
        this.page = e.current
        this.pagination.pageSize = e.pageSize
        this._axios()
        console.log(e)
      },
      onChange(e, dateString) {
        this.startdate = dateString[0]
        this.enddate = dateString[1]
      },
      handleCancel() {
        this.visible = false;
      },
      handleReset() {
        this.sNo = ''
        this.order_sNo = ''
        this.state = undefined
        this.startdate = ''
        this.enddate = ''
      },
      download() {
        this.urls = '?module=pc_api&action=order&m=SettlemntIndex&pageto=';
        this.visible1 = !this.visible1;
      },
      /**
       * @name 导出
       */
      onDownload(pageto) {

        this.$request.download(this.urls + pageto, this.searchData);

      },
    }
  }
</script>

<style lang="less" scoped>
  .Search {
    //display: flex;
    //align-items: center;
    margin-bottom: 20px;
  }

  /deep/ .ant-card-body {
    padding: 24px !important;
  }
</style>